/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const quickFiltersConst = ['QUICK_FILTER_EMPTY', 'QUICK_FILTER_FILLED'];
